import { render, staticRenderFns } from "./comparison-working.vue?vue&type=template&id=452d7e7e&"
import script from "./comparison-working.vue?vue&type=script&lang=js&"
export * from "./comparison-working.vue?vue&type=script&lang=js&"
import style0 from "./comparison-working.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports